import manaratSchoolLogo from './manarat/logo.jpeg';
import baronSchoolLogo from './baron/logo.png';

const CUSTOM_SCHOOLS_DATA = {
  MANARAT: {
    name: 'Manarat Schools',
    arabicName: 'مدارس منارات',
    logo: manaratSchoolLogo,
  },
  BARON: {
    name: 'Baron International School',
    arabicName: 'مدرسة بارون الدولية',
    logo: baronSchoolLogo,
  },
};

const getCustomSchoolData = () => {
  const school = window.location.hostname.split('.')[0].toUpperCase();
  if (school in CUSTOM_SCHOOLS_DATA) {
    return CUSTOM_SCHOOLS_DATA[school];
  }
  return null;
};

export default getCustomSchoolData;
